/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimCheckpointBody
 */
export interface ClaimCheckpointBody {
    /**
     * The checkpoint threshold to claim
     * @type {number}
     * @memberof ClaimCheckpointBody
     */
    threshold: number;
}

/**
 * Check if a given object implements the ClaimCheckpointBody interface.
 */
export function instanceOfClaimCheckpointBody(value: object): value is ClaimCheckpointBody {
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    return true;
}

export function ClaimCheckpointBodyFromJSON(json: any): ClaimCheckpointBody {
    return ClaimCheckpointBodyFromJSONTyped(json, false);
}

export function ClaimCheckpointBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCheckpointBody {
    if (json == null) {
        return json;
    }
    return {
        
        'threshold': json['threshold'],
    };
}

export function ClaimCheckpointBodyToJSON(json: any): ClaimCheckpointBody {
    return ClaimCheckpointBodyToJSONTyped(json, false);
}

export function ClaimCheckpointBodyToJSONTyped(value?: ClaimCheckpointBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threshold': value['threshold'],
    };
}

